"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _formContext = require("../form-context");

var _field = require("../field");

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var CheckboxGroupComponent = function CheckboxGroupComponent(_ref) {
  var name = _ref.name,
      children = _ref.children,
      getValue = _ref.getValue,
      getErrors = _ref.getErrors,
      setValue = _ref.setValue,
      setTouched = _ref.setTouched,
      _onChange = _ref.onChange;
  var childApi = {
    name: name,
    getValue: getValue,
    setTouched: setTouched,
    onChange: function onChange(event) {
      event.persist();
      var rawValue = event.currentTarget.getAttribute('value');
      var value = rawValue ? (0, _helpers.jsonToValue)(rawValue) : null;
      var checked = getValue() || [];
      setValue(checked.length > 0 && checked.includes(value) ? checked.filter(function (item) {
        return item !== value;
      }) : [].concat(_toConsumableArray(checked), [value]), function () {
        if (_onChange) {
          _onChange(event);
        }
      });
    }
  };
  return _react["default"].createElement(_formContext.ContextCheckboxGroup.Provider, {
    value: childApi
  }, children);
};

CheckboxGroupComponent.displayName = 'CheckboxGroup';
var CheckboxGroup = (0, _field.Field)(CheckboxGroupComponent);
exports.CheckboxGroup = CheckboxGroup;